<div class="col-xl">
    <div class="card mb-4">
        <div class="card-body">
            <div class="d-flex justify-content-start mb-2">
                <input #driverCsvInput type="file" accept=".csv,text/csv" style="display:none" (change)="onCsvSelected($event)" />
                <div class="btn-group ms-2" [class.show]="actionsOpen" (click)="$event.stopPropagation()">
                    <button type="button" class="btn btn-outline-primary dropdown-toggle" (click)="$event.stopPropagation(); toggleActionsDropdown()" [attr.aria-expanded]="actionsOpen ? 'true' : 'false'">
                        Acciones
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end" [class.show]="actionsOpen" (click)="$event.stopPropagation(); closeActionsDropdown()">
                        <li>
                            <button class="dropdown-item" type="button" (click)="openCsvPicker(driverCsvInput)">Importar CSV</button>
                        </li>
                        <li><hr class="dropdown-divider"></li>
                        <li>
                            <button class="dropdown-item" type="button" (click)="exportCsv()">Exportar CSV</button>
                        </li>
                    </ul>
                </div>
            </div>
            <ag-grid-angular style="width: 100%; height: 60vh;" class="ag-theme-alpine" [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef" [rowData]="rowData" [animateRows]="true"
                [loadingCellRenderer]="loadingCellRenderer" [loadingCellRendererParams]="loadingCellRendererParams"
                (gridReady)="onGridReady($event)"></ag-grid-angular>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>